export const LIVE_GAME_COMMON_SEATS_COUNT = 7;
